/* eslint-disable no-underscore-dangle */

'use strict';

define('vb/private/stateManagement/router/stateChange',[], () => {
  /**
   * @typedef {import('vb/private/stateManagement/router/vbRouter').default} VbRouter
   * @typedef {typeof import('vb/private/stateManagement/router/vbRouter').default} VbRouterClass
   * @typedef {import('vb/private/stateManagement/router/vbRouterState').default} VbRouterState
   */

  /**
   * An object use to represent a change in a RouterState
   */
  class StateChange {
    /**
     * Constructs a new instance.
     *
     * @param {VbRouter} router
     * @param {string=} value
     */
    constructor(router, value) {
      this.router = router;

      /**
       * @type {string|undefined}
       */
      this.value = value; // the value is also the stateId

      this.state = undefined;
    }

    /**
     * Returns the RouterState object for the state id in this change object
     * @return {VbRouterState} the RouterState matching the value
     */
    getState() {
      if (!this.state) {
        if (this.value) {
          const RouterClass = /** @type {VbRouterClass} */ (this.router.constructor);
          this.state = this.router._getStateFromId(RouterClass.getShortId(this.value));
        }
      }

      return this.state;
    }

    /**
     * Store a state parameter value by appending it to the value as a path
     * @param {string=} value
     */
    addParameter(value) {
      if (value) {
        this.value = `${this.value}/${value}`;
      }
    }
  }

  return StateChange;
});

